import { View } from "react-native"

export const NativePdfView = View

export type PdfRef = {
  setPage: (pageNumber: number) => void
}

export type PdfProps = Record<string, unknown>
